import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import {
    Button,
    Grid
} from "@mui/material";
import { useEffect } from "react";
import GetAsignaturas from "../../data/GetAsignaturas";
import GetNiveles from "../../data/GetNiveles";
import DescripcionTareaAutoCoevaluacion from "../../components/Form/Fields/DescripcionTareaAutoCoevaluacion";
import ElementosClaveVerificar from "../../components/Form/Fields/ElementosClaveVerificar";
import TipoTarea from "../../components/Form/Fields/TipoTarea";
import TituloRubrica from "../../components/Form/Fields/TituloRubrica";
import ListaCotejoCardImg from "../../components/UmmIApps/Cards/ListaCotejoCardImg.png";
import GetObjetivosAprendizaje from "../../components/ObjetivosAprendizaje/GetObjetivosAprendizaje";
import { useActividadesContext } from "../../components/UmmIACategories/Hook/useActividades";
import UmmiaAppsLayout from "../../components/UmmIACategories/Layout/UmmiaAppsLayout";
import { useAuthContext } from "../../hooks/Auth";
import { OASProvider } from "../../context/SuperAdmin/OASContexts/OASContext";
import CurriculumTabs from "../../components/CurriculumTabs/CurriculumTabs";
import { isSendButtonDisabled } from "../../config/sendButtonRules";

const ListaCotejoPage = () => {
  const {
    nivelId,
    materiaId,
    handleBack,
    promptData,
    toggleCamposAvanzados,
    mostrarCamposAvanzados,
    setTextoInicial,
    isOAAdded,
    handleNivelChange,
    handleAsignaturaChangeLocal,
    handleInitialPromptData,
    handleNivelTPChange,
    handleAsignaturaTPChangeLocal,
    clearTP,
    setPromptData,
    nivelTPId,
    asignaturaTPId,
  } = useActividadesContext();

  const { user } = useAuthContext();

  //Variable para condicionar la habilitación del botón "Generar"
  const isButtonDisabled =  isSendButtonDisabled("cotejo", { promptData });
  const colorIconBack = "#E29930";

  useEffect(() => {
    const init = {
      tipo_actividad: "",
      titulo: "",
      descripcion_actividad: "",
      elementos: [],
    };
    handleInitialPromptData(init, "cotejo");
    setTextoInicial(
      "Esta es la propuesta que tengo para ti. Puedes revisarla y modificar cualquier parte según tus necesidades. Ajusta los parámetros en 'Mostrar campos', genera una nueva versión con 'Volver a generar' o personaliza el contenido con 'Editar'. Si prefieres trabajar en otra plataforma, usa 'Copiar' para llevar el texto donde desees."
    );
  }, []);

  return (
    <>
      <UmmiaAppsLayout
        onBack={handleBack}
        imageSrc={ListaCotejoCardImg}
        backgroundColorImage={
          "linear-gradient(180deg, #FFFFFF 0%, #F8ED9B 100%, #F1DB37 100%)"
        }
        titleColor="#F9A825"
        title="Listas de Cotejo"
        description="Diseña un instrumento de evaluación que te permita registrar de forma precisa y eficiente la presencia o ausencia de elementos clave en las tareas o desempeños de tus estudiantes, facilitando una evaluación rápida y consistente."
        isButtonDisabled={isButtonDisabled}
        colorIconBack={colorIconBack}
      >
        <Grid container spacing={2}>
          <Grid item xs={12}>
           
              <CurriculumTabs
                nivelId={nivelId}
                materiaId={materiaId}
                nivelTPId={nivelTPId}
                asignaturaTPId={asignaturaTPId}
                handleNivelChange={handleNivelChange}
                handleNivelTPChange={handleNivelTPChange}
                handleAsignaturaChangeLocal={handleAsignaturaChangeLocal}
                handleAsignaturaTPChangeLocal={handleAsignaturaTPChangeLocal}
                clearTP={clearTP}
                promptData={promptData}
                setPromptData={setPromptData}
              />
          
          </Grid>
        </Grid>

        <Grid item xs={12} sm={12} md={12} lg={12} xl={12} sx={{ mb: 3, mt: 3 }}>
          <TipoTarea />
        </Grid>
        <Grid item xs={12}>
          <TituloRubrica />
        </Grid>
        <Grid item xs={12}>
          <DescripcionTareaAutoCoevaluacion />
        </Grid>
        <Grid item xs={12} container justifyContent="center" sx={{ mb: 3 }}>
          <Button
            variant="text"
            sx={{ color: "#336B87" }}
            onClick={toggleCamposAvanzados}
            endIcon={
              mostrarCamposAvanzados ? <ExpandMoreIcon /> : <ExpandMoreIcon />
            }
          >
            {mostrarCamposAvanzados
              ? "Ocultar opciones avanzadas"
              : "Mostrar opciones avanzadas (opcional)"}
          </Button>
        </Grid>
        {/* Campos avanzados */}
        {mostrarCamposAvanzados && (
          <>
            <Grid item xs={12}>
              <ElementosClaveVerificar
                promptData={promptData}
                setPromptData={setPromptData}
              />
            </Grid>
          </>
        )}
      </UmmiaAppsLayout>
    </>
  );
};

export default ListaCotejoPage;
